import React,{Component} from 'react';

import {Row,Col,Button,Pagination} from 'react-bootstrap';

import API from '../../services/API';

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Icon from '../../components/Icon';
import Form from './components/Form';
import SearchForm from './components/SearchForm';
import PayoutsTable from './components/PayoutsTable';
import {API_URL} from "../../data/config";
import {objToQs} from "../../services/API/Utils";
import SyncMessage from "../../components/SyncMessage";

class Payouts extends Component {
    constructor() {
        super();

        this.state = {
            countries: [],
            pagesTotal: 0,
            activePage: 1,
            rows: [],
            isShowForm: false,
            isLoading: false,
            payoutToUpdate: null,
            search: null,
            syncData: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchReset = this.handleSearchReset.bind(this);
    }

    componentDidMount() {
        this.loadCountries();
        this.loadPayouts();
    }

    componentDidUpdate(nextProps,prevState) {
        if(this.state.activePage !== prevState.activePage || this.state.search !== prevState.search) {
            this.loadPayouts();
        }
    }

    loadCountries() {
        API.Users.getCountries().then((countries) => {
            this.setState({countries});
        });
    }

    loadPayouts() {
        const {activePage, search} = this.state;
        this.setState({
            isLoading: true
        });

        API.Payout.getPage(activePage, search).then((res) => {
            this.setState({
                ...res,
                isLoading: false
            });
        });
    }

    getForm() {
        if(this.state.isShowForm) {
            return (
                <Form
                    countries={this.state.countries}
                    onFormHide={this.handleFormHide}
                    onSubmit={this.handleFormSubmit}
                    payout={this.state.payoutToUpdate}
                />
            );
        }
    }

    handleAddBtnClick() {
        this.setState({
            isShowForm: true
        });
    }

    handleFormHide() {
        this.setState({
            isShowForm: false,
            payoutToUpdate: null
        });
    }

    handleFormSubmit(payout) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            payoutToUpdate: null
        });

        API.Payout.save(payout).then(() => {
            let {rows} = this.state;

            let index = rows.findIndex((item) => {
                return item.affid === payout.affid;
            });
            if(index === -1) {
                rows.push(payout);
            }

            rows[index] = payout;

            this.setState({
                isLoading: false,
                rows
            });
        });
    }

    handleUpdateBtnClick(affid) {
        const {rows} = this.state;

        const payout = rows.find((item) => item.affid === affid);

        this.setState({
            isShowForm: true,
            payoutToUpdate: payout
        });
    }

    handleRemoveBtnClick(affid) {

        this.setState({
            isLoading: true
        });

        API.Payout.remove(affid).then(() => {
            let {rows} = this.state;
            rows = rows.filter(item => {
                return !(item.affid === affid);
            });


            this.setState({
                isLoading: false,
                rows
            });
        });
    }

    handlePageSelect(activePage) {
        this.setState({activePage});
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['app'], 'payout', 8081)
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
            });
    }

    handleSearch(search) {
        this.setState({ search, activePage: 1 });
    }

    handleSearchReset() {
        this.setState({ search: '', activePage: 1 });
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Payouts"/>
                {this.getForm()}
                <SearchForm onSubmit={this.handleSearch} onReset={this.handleSearchReset}/>
                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15" bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                        <Button className="pull-right m-b-15 m-r-15" bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        <Button bsStyle="info" href={`${API_URL}payout/csv?${objToQs({ search: this.state.search })}`}>Export CSV</Button>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />

                <PayoutsTable
                    data={this.state.rows}
                    onUpdateBtnClick={this.handleUpdateBtnClick}
                    onRemoveBtnClick={this.handleRemoveBtnClick}
                />
                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}


export default Payouts;




// WEBPACK FOOTER //
// ./src/scenes/Payouts/index.js